import { Dispatch } from "redux";

export const setParentData = (data: any) => {
    return (dispatch: Dispatch) => {
        dispatch({ type: "SET_PARENT_DATA", payload: data });
    };
};
